import { Component } from 'vue-property-decorator'

import { ApiCallError, ERROR_MAP } from '@src/lib/api_client'
import { API } from '@src/lib/api_path'
import ChangePassword from '@src/routes/members/components/account/change-password'
import { CreateElement } from 'vue'
import { Input } from '@src/elements/input/input'
import { InputFootnote } from '@src/elements/input/input-footnote'
import { validatePassword, validateRequiredField } from '@src/util/validation'
import SessionManager from '@src/lib/session_manager'

@Component({
  computed: {
    email () {
      return this.$store.state.memberProfile.email
    }
  }
})
export default class MemberChangePassword extends ChangePassword {

  protected email: string

  private currentPassword: string = ''
  private isValidCurrentPassword: boolean = true

  constructor () {
    super()
  }

  resetPassword () {
    this.missingEmailError = false

    return this.apiClient.post(API.MEMBERS_API.REQUEST_RESET_PASSWORD, { email: this.email })
      .then(() => this.$store.dispatch('showToast', { message: this.$t('PAGE.MEMBERS.CHANGE_PASSWORD.RESET_EMAIL_SENT'), fadeOut: true }))
      .catch(() => this.missingEmailError = true)

  }

  validate () {
    this.isValidCurrentPassword = !validateRequiredField(this.currentPassword)
    this.isValidPassword = validatePassword(this.newPassword)
    this.isValidConfirmPassword = this.newPassword === this.confirmPassword
  }

  submitNewPassword () {
    this.apiClient.put(API.MEMBERS_API.PASSWORDS.replace('{currentPassword}', this.currentPassword).replace('{newPassword}', this.newPassword), {})
      .then(() => {
        this.$store.dispatch('showToast', { message: this.$t('PAGE.MEMBERS.CHANGE_PASSWORD.CHANGE_PASSWORD_DONE'), fadeOut: true })
        this.newPassword = ''
        this.confirmPassword = ''
        this.currentPassword = ''
        SessionManager.Instance.logout()
        window.location.reload.call(window.location)
      })
      .catch((error: ApiCallError) => {
        if (error.messageKey === ERROR_MAP['422']) {
          this.isValidPassword = false
        }
        if (error.messageKey === ERROR_MAP['401'] || error.messageKey === ERROR_MAP['403']) {
          this.isValidCurrentPassword = false
        }
      })
  }

  renderChangePasswordForm (h: CreateElement) {
    return <div>
      <div class='row'>
        <Input ref='currentPassword' type='password' class={`short ${!this.isValidCurrentPassword ? 'error' : ''}`} value={this.currentPassword}
               valueChanged={(value: string) => this.currentPassword = value} label={`${this.$t('PAGE.MEMBERS.CHANGE_PASSWORD.CURRENT')}*`} />
      </div>

      <div class='row'>
        <div class='short'>
          <Input ref='newPassword' type='password' class={!this.isValidPassword ? 'error' : ''} value={this.newPassword} valueChanged={this.setNewPassword}
                 label={`${this.$t('PAGE.MEMBERS.CHANGE_PASSWORD.NEW')}*`} />
          {this.missingEmailError ? <InputFootnote class='error'>
            <span class='error'>{this.$t('PAGE.MEMBERS.CHANGE_PASSWORD.CHANGE_PASSWORD_MISSING_EMAIL')}</span>
          </InputFootnote> : null}
        </div>
      </div>

      <div class='row'>
        <Input ref='confirmPassword' type='password' class={`short ${!this.isValidConfirmPassword ? 'error' : ''}`} value={this.confirmPassword}
               valueChanged={this.setConfirmPassword} label={`${this.$t('PAGE.MEMBERS.CHANGE_PASSWORD.CONFIRM')}*`} />
      </div>
    </div>
  }
}
